export const orderApi = {
    list: {
        method: 'post',
        api: 'admin/orders/list'
    },
    save: {
      method: 'post',
      api: 'admin/orders/save'
    },
    get: {
      method: 'post',
      api: 'admin/orders/get'
    },
    del: {
      method: 'post',
      api: 'admin/orders/del'
    },
    changeStatus: {
      method: 'post',
      api: 'admin/orders/changeStatus'
    },
  }